import { Button, buttonVariants } from "@/components/ui/button";
import { buildMetadata } from "@/lib/metadata";
import { cn } from "@/lib/utils";
import { useAuth } from "@/providers/auth";
import { Link, createFileRoute } from "@tanstack/react-router";
import { GoogleIcon } from "./-icons/icons";
import { MicrosoftIcon, ZohoIcon } from "./-icons/icons";

export const Route = createFileRoute("/_auth/sign-up")({
  component: RouteComponent,
  head: () => ({
    meta: buildMetadata({
      title: "Sign Up",
      description: "Sign up for an account",
      keywords: ["sign up", "account", "register"],
    }),
  }),
});

function RouteComponent() {
  const { isLoading, attachProvider, signUp } = useAuth();

  return (
    <div className="space-y-10">
      <div className="space-y-2">
        <h1 className="font-medium text-5xl">Sign Up</h1>
        <span>Please sign up to create an account.</span>
      </div>

      <div className="space-y-2">
        <Button
          className="w-full"
          variant="outline"
          disabled={isLoading}
          onClick={() => attachProvider("google", "login")}
        >
          <GoogleIcon />
          Sign up with Google
        </Button>
        <Button
          className="w-full"
          variant="outline"
          disabled={isLoading}
          onClick={() => attachProvider("microsoft", "login")}
        >
          <MicrosoftIcon />
          Sign up with Microsoft
        </Button>
        <Button
          className="w-full"
          variant="outline"
          disabled={isLoading}
          onClick={() => attachProvider("zoho", "login")}
        >
          <ZohoIcon />
          Sign up with Zoho
        </Button>
      </div>

      <div className="mx-auto w-fit text-muted-foreground text-sm">
        Have an account?{" "}
        <Link
          to="/sign-in"
          className={cn(
            buttonVariants({ variant: "link" }),
            "w-fit px-0 underline",
          )}
        >
          Sign in
        </Link>
      </div>
    </div>
  );
}
